export default __webpack_public_path__ + "static/media/navbar-icon-report.68a19ca4.svg";